// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"001a5a38","521":"033f8c59","2606":"033f8c59","3282":"033f8c59","5169":"9d9feace","7449":"cc00fa56","8973":"ecf67f2c","9077":"033f8c59","9551":"e92a228e"}[chunkId] + ".chunk.css";
};